<template>
  <v-card v-if="restaurant" class="mb-4" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-map-marker</v-icon>
      {{ $t("delivery_locations") }}
    </v-card-title>
    <v-card-text class="pt-4">
      <v-row dense>
        <v-col cols="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.type_of_delivery.delivery_to_user_address"
            :label="$t('delivery_to_address')"
            hide-details
            dense
            color="deep-orange"
            @change="save"
          ></v-checkbox>
        </v-col>
        <v-col cols="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.type_of_delivery.delivery_to_firm"
            :label="$t('delivery_to_company')"
            hide-details
            dense
            color="deep-orange"
            @change="save"
          ></v-checkbox>
        </v-col>
        <v-col cols="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.type_of_delivery.restaurant_eat"
            :label="$t('restaurant_meal')"
            hide-details
            dense
            color="deep-orange"
            @change="save"
          ></v-checkbox>
        </v-col>
        <v-col cols="6">
          <v-checkbox
            v-model="restaurant.company_restaurant_settings.type_of_delivery.take_by_user"
            :label="$t('take_yourself')"
            hide-details
            dense
            color="deep-orange"
            @change="save"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "DeliveryLocationsCard",
  mixins: [hasSnackbar],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    deliveryTime: {
      type: String,
      default: "no_delivery_time",
    },
  },
  methods: {
    save() {
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
</style>
